import { render, staticRenderFns } from "./ExpandedBudgetStructure.vue?vue&type=template&id=38356818&"
import script from "./ExpandedBudgetStructure.vue?vue&type=script&lang=ts&"
export * from "./ExpandedBudgetStructure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports